module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_phone.3e84cd55.svg";